export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const SET_DASHBOARD_DATA = "SET_DASBHOARD_DATA";
export const GET_CONTACT_CONVERSIONS = "GET_CONTACT_CONVERSIONS";
export const SET_CONTACT_CONVERSIONS = "SET_CONTACT_CONVERSIONS";
export const SET_DASHBOARD_FILTER = "SET_DASHBOARD_FILTER";
